/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { configureStore } from '@reduxjs/toolkit';

import { externalAPI } from './api/external-api.slice';
import { versionAPI } from './api/version-api.slice';
import { GatedSlice, MessageSlice } from './slices';

const store = configureStore({
	reducer: {
		message: MessageSlice.reducer,
		gated_content: GatedSlice.reducer,
		[versionAPI.reducerPath]: versionAPI.reducer,
		[externalAPI.reducerPath]: externalAPI.reducer
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: {
				ignoredActions: [
					'dialog/openDialog',
					'dialog/closeDialog',
					'message/showMessage',
					'message/hideMessage'
				]
			}
		}).concat(versionAPI.middleware, externalAPI.middleware),
	devTools: process.env.NODE_ENV === 'development'
});

window.store = store;

export default store;
